const Progress = (gameInstance, progress) => {
  //console.log("unity progress called");

  if (!gameInstance.Module)
    return;
  if (!gameInstance.logo) {
  //  gameInstance.logo = document.createElement("div");
    //gameInstance.logo.className = "logo " + gameInstance.Module.splashScreenStyle;
  //gameInstance.container.appendChild(gameInstance.logo);
    gameInstance.logo = document.createElement("span");
    gameInstance.logo.setAttribute("class", "loadingText");
    gameInstance.logo.textContent="Loading Spendor";
    gameInstance.container.appendChild(gameInstance.logo);
  }
  if (!gameInstance.progress) {
    gameInstance.progress = document.createElement("span");
    gameInstance.progress.setAttribute("class", "loadingText2");
    gameInstance.progress.textContent=".";
    gameInstance.container.appendChild(gameInstance.progress);
    /*
    gameInstance.progress = document.createElement("div");
    gameInstance.progress.className = "progress " + gameInstance.Module.splashScreenStyle;
    gameInstance.progress.empty = document.createElement("div");
    gameInstance.progress.empty.className = "empty";
    gameInstance.progress.appendChild(gameInstance.progress.empty);
    gameInstance.progress.full = document.createElement("div");
    gameInstance.progress.full.className = "full";
    gameInstance.progress.appendChild(gameInstance.progress.full);
    gameInstance.container.appendChild(gameInstance.progress);*/
  }
  //console.log("progress: "+progress);
  let prog = Math.floor(progress * 10);
  //gameInstance.progress.textContent = gameInstance.progress.textContent + ".";
  gameInstance.progress.textContent = ".".repeat(prog);
  //gameInstance.progress.full.style.width = (100 * progress) + "%";
  //console.log("Progress is ",progress);
  //gameInstance.progress.empty.style.width = (100 * (1 - progress)) + "%";
  if (progress == 1)
    //gameInstance.logo2.style.display = "none";
    gameInstance.logo.style.display = gameInstance.progress.style.display = "none";
}

export default Progress;
